import { NextPageContext } from "next";
import Affiliate from "../../components/Affiliate";
import { getPageContent } from "../../utils/contentFetcher";
import { useMemo } from "react";
import { AffiliateContent } from ".";

const ReferralSetPasswordPage = ({content}:{content: AffiliateContent}) => {

  const resetPasswordComponent = useMemo(() => (
    <Affiliate modalType="setPassword" content={content} />
), [content]);

  return resetPasswordComponent;
}
export default ReferralSetPasswordPage;

export async function getServerSideProps(ctx: NextPageContext) {
  const res = await getPageContent("affiliate", ctx);
  return {
    props: {
      content: res.data,
    },
  };
}